import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import IAction from "../models/IAction";
import UtenteAction from "stores/utente/UtenteAction";
import ValidationUtility from "utilities/ValidationUtility";
import IStore from "models/IStore";

const cookieConsentMiddleware = (): Middleware => (store: MiddlewareAPI<Dispatch, IStore>) => (next: Dispatch) => (
    action: IAction<any>
): void => {
    if (store.getState().utente.profilo.isCookieAllowed === false) {
        const cookieValue = ValidationUtility.getCookie("ccq-cookie-consent");
        const consent = cookieValue === "true";
        if (consent === true) {
            next(UtenteAction.cookieConsentSet(consent));
        }
    }

    next(action);
};

export default cookieConsentMiddleware;
